module.exports = {"name":"Delivery Dashboard","version":"v2.1-265-g4867e26","source":"https://github.com/mozilla/delivery-dashboard.git","commit":"4867e262730cd92d40b9c9ee3da36a9b2beb17f9"}


//////////////////
// WEBPACK FOOTER
// ./src/version.json
// module id = 255
// module chunks = 0